import { InfoIcon } from 'assets/icons/withContainer';
import styled from 'styled-components';

export const HintIcon = styled(InfoIcon)`
  cursor: pointer;
  height: 20px;
  width: 20px;
`;
